// Shopify CDN: Skip minification

export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in localStorage */
  static #STORAGE_KEY = 'viewedProducts';

  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 8;

  /**
   * Adds a product handle to the recently viewed products list.
   * @param {string} productHandle - The handle (slug) of the product to add.
   */
  static addProduct(productHandle) {
    if (!productHandle) return;

    let viewedProducts = this.getProducts();

    // Remove duplicate if already exists
    viewedProducts = viewedProducts.filter((h) => h !== productHandle);

    // Add to front (most recent first)
    viewedProducts.unshift(productHandle);

    // Limit to max
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (e) {
      console.warn('RecentlyViewed: could not write to localStorage', e);
    }
  }

  /**
   * Retrieves the list of recently viewed product handles from localStorage.
   * @returns {string[]} The list of product handles.
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  /**
   * Clears all recently viewed products from localStorage.
   */
  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }
}
